'use strict';

$('.experience-commerce_assets-mainBanner').on('click', function () {
    location.reload();
});
